export var ACTIONS = {
  SET_RECEIVED: 'SET_RECEIVED',
  SET_GRANTED: 'SET_GRANTED',
  SET_REQUESTS: 'SET_REQUESTS',
  SET_REQUESTS_PENDING: 'SET_REQUESTS_PENDING',
  SET_REVOKE_GRANTED_AUTHORIZATION: 'SET_REVOKE_GRANTED_AUTHORIZATION',
  SET_POST_AUTHORIZATION_STATUS: 'SET_POST_AUTHORIZATION_STATUS',
  CLEAR_POST_AUTHORIZATION_STATUS: 'CLEAR_POST_AUTHORIZATION_STATUS',
  SET_REVOKING_STATUS: 'SET_REVOKING_STATUS',
  CLEAR_REVOKING_STATUS: 'CLEAR_REVOKING_STATUS',
  SET_UPDATING_REQUEST_STATUS: 'SET_UPDATING_REQUEST_STATUS',
  CLEAR_UPDATING_REQUEST_STATUS: 'CLEAR_UPDATING_REQUEST_STATUS'
};